export default __webpack_public_path__ + "static/media/gully_02.3a9f7336.png";